(function () {
  var $slider = $('.hc-main-slider-default');
  if (!$slider.length) return;

  var sliderEl = $slider[0];
  var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
  if (!wrapperEl) {
    $slider.removeClass('hc-loading');
    return;
  }

  var masterSlidesHTML = wrapperEl.innerHTML;
  var hcMainDefault = null;

  function handleize(str) {
    return String(str || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getSelectedValueByHandle(handle) {
    var fieldset = document.querySelector('.variant-input-wrap[data-handle="' + handle + '"]');
    if (!fieldset) return '';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? handleize(checked.value) : '';
  }

  function initSwiper() {
    return new Swiper('.hc-main-slider-default', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      centeredSlides: true,
      autoHeight: true,
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    });
  }

  function rebuild() {
    wrapperEl.innerHTML = masterSlidesHTML;

    var hcVariants = String($slider.attr('data-variants') || '');
    if (hcVariants !== '1') {
      var sizeVal = getSelectedValueByHandle('size');
      var colorVal = getSelectedValueByHandle('color');

      var slides = Array.prototype.slice.call(wrapperEl.querySelectorAll('.swiper-slide'));
      slides.forEach(function (slide) {
        if (sizeVal && !slide.classList.contains('hc-' + sizeVal)) slide.remove();
      });

      slides = Array.prototype.slice.call(wrapperEl.querySelectorAll('.swiper-slide'));
      slides.forEach(function (slide) {
        if (colorVal && !slide.classList.contains('hc-' + colorVal)) slide.remove();
      });
    }

    if (hcMainDefault && hcMainDefault.destroy) {
      hcMainDefault.destroy(true, true);
      hcMainDefault = null;
    }

    hcMainDefault = initSwiper();
    hcMainDefault.update();
    hcMainDefault.slideTo(0, false);

    $slider.removeClass('hc-loading');
  }

  rebuild();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches && t.matches('input[data-variant-input]')) rebuild();
  });
})();
